<mat-card appearance="outlined">
  <mat-card-title [innerText]="'MAIN_APP_SERVICE_APP.artikelstamm' | translate"></mat-card-title>
  <mat-card-content>
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.filter" | translate }} </mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Begriff eingeben" #input />
      </mat-form-field>
    </span>

    <span>
      <mat-spinner *ngIf="isLoadingResults" style="margin: 0 auto"></mat-spinner>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Artikel-Nr. Column -->
        <ng-container matColumnDef="productNo">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_SERVICE_APP.artikelnummer" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.productNo }}</td>
        </ng-container>

        <!-- Bezeichnung Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_SERVICE_APP.bezeichnung" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.shortText }}</td>
        </ng-container>

        <!-- Preis pro Einheit Column -->
        <ng-container matColumnDef="pricePerQuantity">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_SERVICE_APP.preisLagereinheit" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.salePrice }} / {{ element.stockUnit }}
          </td>
        </ng-container>

        <!-- Suchbegriff Column -->
        <ng-container matColumnDef="searchKey">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_SERVICE_APP.suchbegriff" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.searchKey }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ highlight: selectedProductNo == row.productNo }" (click)="highlight(row)"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="10">
            {{ "MAIN_APP_SERVICE_APP.noDataMatchingTheFilter" | translate }} "{{ input.value }}"
          </td>
        </tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true"></mat-paginator>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!productIsChoosed" [innerText]="'MAIN_APP_SERVICE_APP.artikelErfassen' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
